var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagGermany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.995193 21.5768C3.25588 27.6695 9.12057 32.0116 16 32.0116C22.8794 32.0116 28.7441 27.6695 31.0048 21.5768L16 20.1855L0.995193 21.5768Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0.0117188C9.12057 0.0117188 3.25588 4.35372 0.995193 10.4465L16 11.8378L31.0048 10.4465C28.7441 4.35372 22.8794 0.0117188 16 0.0117188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.995188 10.4465C0.352063 12.1798 0 14.0546 0 16.0117C0 17.9688 0.352063 19.8436 0.995188 21.5769H31.0049C31.648 19.8436 32 17.9688 32 16.0117C32 14.0546 31.648 12.1798 31.0048 10.4465H0.995188Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0117188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagGermany);
export default __webpack_public_path__ + "static/media/flag_germany.bd6d5714669d428c54482c76c2a8004f.svg";
export { ForwardRef as ReactComponent };